import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { cueIcon, IconComponent } from '@cue/ui/icons';
import { NgClass } from '@angular/common';

@Component({
  selector: 'cue-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgClass],
})
export class ButtonComponent {
  color = input(null);
  disabled = input(false);
  icon = input<cueIcon>();
  type = input('primary');
  smallResponsive = input(false);
  smallResponsiveAllways = input(false);
  btnClass = input('');

  // Pass all classNames to inner button
  getClasses() {
    return 'button-container ' + this.type() + ' ' + this.btnClass();
  }
}
